(function() {
    'use strict';

    angular
        .module('app')
        .factory('FileService', function($q) {
            return {
                readFile: function (file) {

                    var deferred = $q.defer();

                    var fileReader = new FileReader();

                    fileReader.readAsDataURL(file);

                    fileReader.onload = function () {
                        deferred.resolve({
                            contentType: file.type,
                            fileName: file.name,
                            size: file.size,
                            base64EncodedFileContents: fileReader.result
                        });
                    };

                    fileReader.onerror = function (error) {
                        deferred.reject(error);
                    };

                    return deferred.promise;
                }
            };
        });
})();
